<div
	class="
		container-fluid
		xl:zk-w-6/12
		lg:zk-w-7/12
		md:zk-w-12/12
		xl:zk-py-32
		lg:zk-py-6
		md:zk-py-6
		sm:zk-py-6
	"
>
	<section class="align-center welcome-content">
		<h1 class="title lg:zk-mb-8 md:zk-mb-6 sm:zk-mb-6">
			{{ 'SIGN_UP.WELCOME.TITLE' | translate }}
		</h1>
		<div class="content">
			<div class="content-description">
				<p class="zk-mb-2">
					{{ 'SIGN_UP.WELCOME.CONTENT' | translate }}
				</p>
				<p
					class="zk-font-bold"
					[innerHTML]="
						'SIGN_UP.WELCOME.BUSINESS_FISCAL_ID_REQUIRED' | translate
					"
				></p>
			</div>
			<div class="content-action zk-flex">
				<input
					zkCheckbox
					[checked]="checkActive"
					(change)="changeTerms($event)"
					class="zk-w-checkbox zk-h-checkbox"
					type="checkbox"
					name="terms-and-policy"
				/>
				<label
					for="terms-and-policy"
					class="zk-ml-2 zk-text-2"
					[innerHTML]="'SIGN_UP.WELCOME.TERMS' | translate"
				>
				</label>
			</div>
		</div>
	</section>
</div>
